import { supabase } from './client'

/**
 * Sign out - for use in non-React contexts (error handlers, etc.)
 *
 * This is a minimal utility for signing out outside of React components.
 * For React components, use useAuthActions().signOut() instead.
 *
 * Silently ignores session-related errors (user is already signed out).
 */
export async function signOut() {
  const { error } = await supabase.auth.signOut()

  if (error) {
    // Ignore session-related errors - user is effectively already signed out
    const ignoredCodes = [
      'session_not_found',
      'session_expired',
      'refresh_token_not_found',
    ]

    if (ignoredCodes.includes(error.code ?? '')) {
      return
    }

    throw new Error('Sign-out failed', { cause: error })
  }
}
